import React from "react";
import { css } from "@emotion/css";
import { Segment, Progress, Step, Icon } from "semantic-ui-react";
import "../../styles/steps.scss";
import { getIsWhiteLabeled } from "../../helpers/PermissionHelper";

const BCSteps = ({ ...props }) => {
  const brokerProgressBarOverrideCSS = css`
    .bar {
      background: ${props.brokerColor ? props.brokerColor : "black"}!important;
    }
  `;

  const brokerStepOverrideCSS = css`
    background-color: ${props.brokerColor ? props.brokerColor : "black"}!important;
    &::after {
      background-color: ${props.brokerColor ? props.brokerColor : "black"}!important;
    }
  `;

  return (
    <Segment className="bc-step-segment">
      {props.currentProgress !== 0 && <Progress 
        className={`bc-step-progress ${getIsWhiteLabeled() && brokerProgressBarOverrideCSS}`}
        percent={props.currentProgress} 
        attached='top' 
        active
      />}
      <Step.Group fluid unstackable className="bc-steps">
        {props.steps.map((step, i) => {
          return (
            <Step 
              key={`bc-step-${i}`} 
              className={
                step.completed && !step.active ? "bc-step-completed" :
                step.disabled && !step.visited && !step.active ? "bc-step-disabled" :
                step.visited && !step.active ? "bc-step-visited" :
                `bc-step ${(getIsWhiteLabeled() && !step.active && !step.disabled) && brokerStepOverrideCSS}`
              }
              active={step.active} 
              disabled={step.disabled && !step.visited && !props.isDisableOnClick && (props.isDisabled && step.title === "Summary") && (props.isDisabled && step.title === "Guarantor")} 
              onClick={() => props.handleStep(step.step)}
            >
              <Step.Content>
                <Icon 
                  className={
                    step.completed && !step.active ? "bc-step-completed-icon" :
                    step.disabled && !step.visited && !step.active ? "bc-step-disabled-icon" : 
                    step.visited && !step.active ? "bc-step-visited-icon" : 
                    "bc-step-icon"
                  }
                  style={props.setColor && step.active ? props.setColor : void 0} 
                  name={step.icon as any} 
                  size="big" 
                />
                {props.isGreaterThanMobile && <Step.Title className={
                  step.completed && !step.active ? "bc-step-completed-title" :
                  step.disabled && !step.visited && !step.active ? "bc-step-disabled-title" : 
                  step.visited && !step.active ? "bc-step-visited-title" : 
                  "bc-step-title"
                }>
                  {step.name}
                </Step.Title>}
              </Step.Content>
              
            </Step>
          );
        })}
      </Step.Group>
      {props.currentProgress !== 0 && <Progress 
        className={`bc-step-progress ${getIsWhiteLabeled() && brokerProgressBarOverrideCSS}`} 
        percent={props.currentProgress} 
        attached='bottom' 
        active 
      />}
    </Segment>
  );
};

export default BCSteps;